import React from 'react';

const YogaMeditationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9042 6.96875C13.492 6.96875 14.7792 5.68157 14.7792 4.09375C14.7792 2.50593 13.492 1.21875 11.9042 1.21875C10.3164 1.21875 9.02919 2.50593 9.02919 4.09375C9.02919 5.68157 10.3164 6.96875 11.9042 6.96875Z"
      stroke="#4B4B4B"
    />
    <path
      d="M14.3 12.7721L12.4792 11.4305C12.1917 11.143 11.7125 11.143 11.3292 11.4305L9.50835 12.7721"
      stroke="#4B4B4B"
    />
    <path d="M11.9042 11.2148V14.4013" stroke="#4B4B4B" />
    <path
      d="M6.15418 15.5508C6.15418 16.8515 8.07085 16.9883 9.50835 16.03C9.98752 15.7425 11.5208 14.5925 11.9042 14.4008C12.2875 14.5925 13.8208 15.7425 14.3 16.03C15.7375 16.9883 17.6542 16.6119 17.6542 15.5508V14.1133C17.6542 10.9508 15.0667 8.36328 11.9042 8.36328C8.74168 8.36328 6.15418 10.9508 6.15418 14.1133V15.5508Z"
      stroke="#4B4B4B"
    />
    <path
      d="M13.1113 18.7069L6.79481 16.7183C5.74207 16.3674 4.57237 16.9523 4.22145 18.122C3.87054 19.1747 4.45539 20.3445 5.6251 20.6953L11.9415 22.6839C12.9943 23.0348 14.164 22.4499 14.5149 21.2802C14.7489 20.2275 14.164 19.0577 13.1113 18.7069Z"
      stroke="#4B4B4B"
    />
    <path
      d="M16.9929 20.8257L18.3749 20.3907C19.5446 20.0397 20.1295 18.87 19.7786 17.8173C19.4277 16.6476 18.2579 16.0628 17.2052 16.4136L14.7649 17.1819"
      stroke="#4B4B4B"
    />
  </svg>
);

export default YogaMeditationIcon;
